<div
  class="searchable-dropdown"
  [class.is-open]="isOpen"
  [class.is-focused]="isFocused || isOpen"
  [class.is-disabled]="disabled"
  [class.compact]="compact"
  [class.multi-select]="multiSelect">
  <label *ngIf="label" class="dropdown-label">{{ label }}</label>

  <div class="dropdown-control" (click)="onControlClick($event)">
    <input
      #searchInput
      type="text"
      class="dropdown-input"
      [attr.title]="inputTooltip"
      [placeholder]="placeholder"
      [ngModel]="displayText"
      (ngModelChange)="onSearchInput($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      (keydown)="onKeydown($event)"
      (click)="$event.stopPropagation()"
      [disabled]="disabled"
      autocomplete="off" />

    <div class="dropdown-actions">
      <button
        *ngIf="showClear && !disabled && isOpen && searchText"
        type="button"
        class="action-btn clear-btn"
        (click)="onClearClick($event)"
        tabindex="-1"
        aria-label="Clear search">
        <mat-icon>close</mat-icon>
      </button>
      <button
        *ngIf="showClear && !disabled && hasValue && !isOpen"
        type="button"
        class="action-btn clear-btn"
        (click)="onClearClick($event)"
        tabindex="-1"
        [attr.aria-label]="multiSelect ? 'Clear all selections' : 'Clear selection'">
        <mat-icon>close</mat-icon>
      </button>
      <button
        type="button"
        class="action-btn toggle-btn"
        (click)="toggleDropdown($event)"
        tabindex="-1"
        [disabled]="disabled"
        aria-label="Toggle dropdown">
        <mat-icon>{{ isOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
      </button>
    </div>
  </div>

  <ul
    *ngIf="isOpen"
    #dropdownPanel
    class="dropdown-panel searchable-dropdown-panel"
    [class.searchable-dropdown-panel--compact]="compact"
    [class.dropdown-panel-fixed]="compact"
    [class.dropdown-panel-multi]="multiSelect"
    [ngStyle]="panelStyle"
    role="listbox"
    [attr.aria-multiselectable]="multiSelect">
    <!-- Select All (multi-select only) -->
    <li
      *ngIf="multiSelect && selectableFilteredOptions.length > 0"
      class="dropdown-option dropdown-option-select-all"
      (mousedown)="$event.preventDefault()">
      <div
        class="dropdown-option-check"
        (click)="onSelectAllClick($event)">
        <input
          type="checkbox"
          class="dropdown-checkbox"
          [checked]="isAllFilteredSelected"
          [indeterminate]="isIndeterminateFiltered"
          tabindex="-1"
          aria-hidden="true"
          readonly />
        <span class="dropdown-option-text dropdown-option-text-bold">{{ selectAllLabel }}</span>
      </div>
    </li>

    <ng-container *ngIf="!multiSelect">
      <li
        *ngFor="let option of filteredOptions; trackBy: trackByValue"
        class="dropdown-option"
        [class.selected]="isSelected(option)"
        (mousedown)="selectOption(option, $event)"
        role="option"
        [attr.title]="option.label">
        <span class="dropdown-option-text">{{ option.label }}</span>
      </li>
    </ng-container>

    <ng-container *ngIf="multiSelect">
      <li
        *ngFor="let option of filteredOptions; trackBy: trackByValue"
        class="dropdown-option dropdown-option-multi"
        [class.selected]="isSelected(option)"
        (mousedown)="$event.preventDefault()"
        (click)="toggleMultiOption(option, $event)"
        role="option"
        [attr.aria-selected]="isSelected(option)"
        [attr.title]="option.label">
        <div class="dropdown-option-check">
          <input
            type="checkbox"
            class="dropdown-checkbox"
            [checked]="isSelected(option)"
            tabindex="-1"
            aria-hidden="true"
            readonly />
          <span class="dropdown-option-text">{{ option.label }}</span>
        </div>
      </li>
    </ng-container>

    <li *ngIf="filteredOptions.length === 0" class="dropdown-option no-results">
      No results found
    </li>
  </ul>
</div>
